import React from 'react';
import { Modal, Text, Button } from 'quanta-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

export default function CancelModal({
  showCancelModal,
  setShowCancelModal,
  onCancel,
  onCancelClick,
  cancelTitle,
  cancelText,
}) {
  return (
    <Modal
      size="small"
      display={showCancelModal}
      severity="warning"
      title={
        <Text
          className="flex space-x-3 items-end justify-start w-full"
          type="title"
          severity="warning"
        >
          <Text>
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              size={'lg'}
            />
          </Text>
          <Text type="title">
            {cancelTitle ? cancelTitle : 'Confirm Cancel'}
          </Text>
        </Text>
      }
      onClose={(_) => {
        if (onCancelClick) {
          onCancelClick();
        }
        setShowCancelModal(false);
      }}
    >
      <Text className="flex flex-row space-x-2 justify-start w-full">
        <Text className="flex flex-col space-y-4 justify-start w-full">
          <Text type="normal">
            {cancelText
              ? cancelText
              : 'Are you sure you want to cancel?'}
          </Text>
          <Text className="flex justify-end w-full space-x-4">
            <Text>
              <Button
                size="small"
                type={'button'}
                flat={false}
                className="w-20"
                onClick={(_) => {
                  if (onCancel) {
                    onCancel();
                  }
                  setShowCancelModal(false);
                  document.body.classList.remove('overflow-y-hidden');
                }}
              >
                OK
              </Button>
            </Text>
            <Text>
              <Button
                size="small"
                type={'button'}
                flat
                className="w-20"
                onClick={(_) => {
                  if (onCancelClick) {
                    onCancelClick();
                  }
                  setShowCancelModal(false);
                  document.body.classList.remove('overflow-y-hidden');
                }}
              >
                Cancel
              </Button>
            </Text>
          </Text>
        </Text>
      </Text>
    </Modal>
  );
}
